import React, { useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { boxiPrimary } from '../../assets/style/colors';
import { connect } from "react-redux";
import moment from "moment-timezone";
import * as actionTypes from "../../store/actions/actionTypes";

function SelectionListDuration(props) {

  const updateStartD = (id) => {
    // let startDate = new Date().getTime();
    let startDate = moment().clone().utc().startOf('day').unix() * 1000;
    switch (id) {
      // 1 day
      case 0:
        startDate = moment().clone().subtract(1, 'day').utc().startOf('day').unix() * 1000;
        // startDate -= 1 * 24 * 60 * 60 * 1000;
        break;
      // 1 week (7 days)
      case 1:
        startDate = moment().clone().subtract(7, 'days').utc().startOf('day').unix() * 1000;
        // startDate -= 7 * 24 * 60 * 60 * 1000;
        break;
      // 1 month (30 days)
      case 2:
        startDate = moment().clone().subtract(1, 'month').utc().startOf('day').unix() * 1000;
        // startDate -= 30 * 24 * 60 * 60 * 1000;
        break;
      // all (any other input behaves like all), start at beginning of unix timestamp
      case 3:
      default:
        startDate = 0;
        break;
    }
    // this.props.updateStartDate(startDate, id);
    props.updateStartDate(startDate, id);
  };
  const {classes, items} = props;
  return (
    <List
    style={{width: '60%'}}
      className={classes.selectionList}
    >
      {items.map((value, index) => {
        const labelId = `checkbox-list-label-${value}`;

        return (
          <ListItem
            style={{
              borderBottom: index !== items.length - 1 ? '1px solid lightGray' : '',
              background: index === props.index? boxiPrimary : '#FFFF',
              color: index === props.index ?  '#FFFF' : boxiPrimary,
              fontFamily: 'Poppins'
            }}
            key={value}
            role={undefined}
            dense
            button
            onClick={() => {
              updateStartD(index)
              props.handleTimePeriodClick(index)
            }}
          >
            <ListItemIcon>
            </ListItemIcon>
            <span style={{fontFamily: 'Poppins'}} id={labelId}>{value}</span>
            {/* <ListItemText style={{fontFamily: 'Poppins'}} id={labelId} primary={value}/> */}
          </ListItem>
        );
      })}
    </List>
  );
}


const mapStateToProps = (state) => {
  return {
    index: state.clientDashboard.timePeriod
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateStartDate: (date, id) =>
      dispatch({
        type: actionTypes.UPDATE_START_DATE,
        startDate: date,
        index: id
      })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionListDuration);
